'use client'

import * as React from 'react'
import { useTranslations } from 'next-intl'

import { AskCfTranslationProvider } from '@repo/web-ui/ask-cf/contexts/ask-cf-translation-context'
import { SocialShareDialogProvider } from '@repo/web-ui/ask-cf/contexts/social-share-dialog-context'
import { NotEnoughCoinsDialogProvider } from '@repo/web-ui/ask-cf/contexts/not-enough-coins-dialog-context'
import { DeleteDialogProvider } from '@web/app/[locale]/(web)/masterfeed/contexts/delete-dialog-context'
import { FollowersDialogProvider } from '@web/app/[locale]/(web)/crafter/[slug]/_components/contexts/followers-dialog-context'
import { CreatePostProjectDialogProvider } from '@web/app/[locale]/(web)/masterfeed/_components/create-post-project-dialog/create-post-project-dialog-context'

export const Providers = ({ children }: React.PropsWithChildren) => {
  const t = useTranslations('pages.clubhouse.ask_cf')
  return (
    <SocialShareDialogProvider>
      <NotEnoughCoinsDialogProvider>
        <DeleteDialogProvider>
          <FollowersDialogProvider>
            <CreatePostProjectDialogProvider>
              <AskCfTranslationProvider i18n={t}>{children}</AskCfTranslationProvider>
            </CreatePostProjectDialogProvider>
          </FollowersDialogProvider>
        </DeleteDialogProvider>
      </NotEnoughCoinsDialogProvider>
    </SocialShareDialogProvider>
  )
}
